<template>
  <div class="comp-main">
    <div class="form-item" v-for="(item, index) in formColumn" :key="index">
      <e-form :column="item" :data.sync="formData" :disabled="disabled" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFirst: {
      type: Boolean,
      default: false
    },
    guiGeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    list: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    top: {
      type: String,
      default: '40px'
    }
  },
  data() {
    return {
      beforeSetTimes: 0,
      formColumn: [],
      formData: {},
      timer: null
    }
  },
  watch: {
    formData: {
      handler(newVal, oldVal) {
        let strNewVal = JSON.stringify(newVal)
        let strOldVal = JSON.stringify(oldVal)
        if (strNewVal === strOldVal || strNewVal === '{}') return
        let result = this.$util.deepCopy(this.list)
        result.forEach((item) => {
          item.value = newVal[item.name]
        })
        this.$emit('update:list', result)
        this.$emit('change')
      },
      deep: true,
      immediate: true
    },
    list: {
      handler() {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.initFormColumn()
          this.timer = null
        }, 20)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取字段类型
    getZiDuanType(key) {
      let result = ''
      this.$constant.ziDuanTypeList.forEach((item) => {
        if (item.key === key) result = item.val
      })
      return result
    },
    // 初始化表单列
    initFormColumn() {
      this.formColumn = this.isFirst ? [[], []] : [[]]
      this.list.forEach((item) => {
        let result = {
          type: this.getZiDuanType(item.lei_xing_id),
          field: item.name,
          title: item.name,
          value: '',
          options: [],
          disabled: false,
          hide: !item.is_show,
          width: '160px'
        }

        // 字段类型----------------------------------------------
        let isTextarea = item.lei_xing_id === 3 // 段落
        let isSpec = item.lei_xing_id === 4 // 分隔
        let isDate = item.lei_xing_id === 5 // 日期(年月日)
        let isDateTime = item.lei_xing_id === 6 // 日期(年月日时分秒)
        let isDateRange = item.lei_xing_id === 7 // 日期(日期范围)
        let isSelect = item.lei_xing_id === 8 // 下拉
        let isFile = item.lei_xing_id === 9 // 文件
        let isImage = item.lei_xing_id === 10 // 图片
        let isGongShi = item.lei_xing_id === 11 // 公式

        // 3 段落处理
        if (isTextarea) result.width = '960px'

        // 4 分隔处理
        if (isSpec) {
          result.placeholder = this.$tool.useEnSymbolFenGe(item.set_symbol)
          result.titleMore = result.placeholder
        }

        // 5 日期(年月日)处理
        if (isDate) {
          result.format = 'yyyy-MM-dd'
          result.valueFormat = 'yyyy-MM-dd'
        }

        // 6 日期(年月日时分秒)处理
        if (isDateTime) {
          result.format = 'yyyy-MM-dd HH:mm:ss'
          result.valueFormat = 'yyyy-MM-dd HH:mm:ss'
          result.width = '320px'
        }

        // 7 日期(日期范围)处理
        if (isDateRange) {
          result.format = 'yyyy-MM-dd'
          result.valueFormat = 'yyyy-MM-dd'
          result.width = '320px'
        }

        // 8 下拉处理
        if (isSelect) {
          result.options = this.$util.deepCopy(item.set_options)
        }

        // 9 文件处理
        if (isFile) {
          result.isDelete = true
          result.width = '320px'
        }

        // 10 图片处理
        if (isImage) {
          result.size = '26px'
          result.isDelete = true
          result.width = '320px'
        }
        if (item.name === '商品封面') result.limit = 1

        // 11 公式处理
        if (isGongShi) {
          result.placeholder = '自动计算'
          result.suffix = '公式'
          result.titleMore = item.set_gong_shi.join('')
        }

        // 禁用处理
        let disabledNameList1 = ['商品编码', '单件数量']
        if (disabledNameList1.includes(item.name) || isGongShi) {
          result.disabled = true
        }

        if (item.name === '单价' || item.name === '金额') {
          result.isImportant = true
        }

        // 提示处理
        if (item.name === '商品编码') result.placeholder = '自动生成'
        if (item.name === '规格') {
          let guiGeListHasMm = this.guiGeList.map((item) => `${item}mm`)
          result.placeholder = `${this.guiGeList.join(item.set_symbol)}`
          if (this.guiGeList.length) result.placeholder += '(mm)'
          result.titleMore = `${guiGeListHasMm.join(item.set_symbol)}`
        }

        // 字段值类型处理----------------------------------------------
        let ziDuanStringList = [1, 2, 3, 4, 5, 6, 8, 11]
        let ziDuanArrayList = [7, 9, 10]
        let isFeidString = ziDuanStringList.includes(item.lei_xing_id)
        let isFeidArray = ziDuanArrayList.includes(item.lei_xing_id)
        if (isFeidString) result.value = item.value || ''
        if (isFeidArray) result.value = item.value || []

        // 字段值预设处理----------------------------------------------
        if (this.beforeSetTimes < 3 && !result.value) {
          if (result.title === '单位') {
            if (result.options.length) result.value = result.options[0].val
            this.beforeSetTimes++
          }
          if (result.title === '单件数量') {
            result.value = '1'
            this.beforeSetTimes++
          }
          if (result.title === '数量') {
            result.value = '1'
            this.beforeSetTimes++
          }
        }
        if (this.isFirst) {
          let titleList = [
            '商品名称',
            '规格',
            '单位',
            '单件数量',
            '数量',
            '单价',
            '单件金额',
            '金额'
          ]
          if (!titleList.includes(result.title)) {
            this.formColumn[1].push(result)
          } else {
            this.formColumn[0].push(result)
          }
        } else {
          this.formColumn[0].push(result)
        }
      })

      this.initFormData()
    },
    // 初始化表单数据
    initFormData() {
      this.formData = {}
      this.formColumn.forEach((itemSt) => {
        itemSt.forEach((itemNd) => {
          this.formData[itemNd.field] = itemNd.value
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  .form-item {
    & ~ .form-item {
      margin-top: v-bind(top);
    }
  }
}
</style>
